export default __webpack_public_path__ + "static/media/PoolTogether.93a9906b.svg";